// ProjectSetupDialog.tsx — Create a new project (mpvar metadata fields)
// Maps to: v11 "Drawing Setup / New Drawing" flow
// Calls: newProject(name, jobNumber, client, engineer)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useStore } from '../store/useStore';

export default function ProjectSetupDialog() {
  const newProject = useStore(s => s.newProject);

  const [name,     setName]     = useState('New Project');
  const [job,      setJob]      = useState('');
  const [client,   setClient]   = useState('');
  const [engineer, setEngineer] = useState('');
  const [address,  setAddress]  = useState('');

  function row(label: string, value: string, setter: (v: string) => void) {
    return (
      <div className="dialog-row" key={label}>
        <label className="dialog-label">{label}</label>
        <input
          className="dialog-input"
          type="text"
          value={value}
          onChange={e => setter(e.target.value)}
        />
      </div>
    );
  }

  return (
    <DialogBase
      title="New Project Setup"
      onOk={() => newProject(name, job, client, engineer, address)}
      okLabel="Create"
    >
      {row('Project Name',   name,     setName)}
      {row('Job Number',     job,      setJob)}
      {row('Client / Owner', client,   setClient)}
      {row('Engineer',       engineer, setEngineer)}
      {row('Job Address',    address,  setAddress)}
    </DialogBase>
  );
}
